import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MySolutionHomepageComponent } from '../my-solution-homepage/my-solution-homepage.component';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { SolutionsAppService } from 'src/app/services/solutions-app.service';
import { ShowDialogsComponent } from 'src/app/components/show-dialogs/show-dialogs.component';
@Component({
  selector: 'app-my-solutions',
  template: `
    <div class="sol-section">
      <div class="sec-head">
        <h2>Your solutions</h2>
        <button
          class="btn-primary"
          routerLink="/home/manage-solutions/create-solution"
        >
          <svg
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 5v14M5 12h14" />
          </svg>
          Create solution
        </button>
      </div>

      <div class="sol-list">
        <div
          class="sol-card"
          *ngFor="let solution of availableSolutions; let i = index"
        >
          <div class="sol-ico">
            <svg
              viewBox="0 0 24 24"
              width="22"
              height="22"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="4" width="18" height="13" rx="2" />
              <path d="M8 21h8M12 17v4" />
            </svg>
          </div>

          <div class="sol-mid">
            <div
              class="sol-nm"
              *ngIf="solution['solution_name']?.length > 45"
              [matTooltip]="solution['solution_name']"
            >
              {{ solution['solution_name'] | namingsize : 45 }}
            </div>
            <div class="sol-nm" *ngIf="solution['solution_name']?.length <= 45">
              {{ solution['solution_name'] | namingsize : 45 }}
            </div>
            <div class="sol-when">
              Created {{ solution['created_dtm'] | date : 'dd MMMM yyyy' }}
            </div>
          </div>

          <div class="sol-actions">
            <button
              class="btn-open"
              [routerLink]="
                '/home/manage-solutions/mySolutions' +
                '/' +
                solution['solution_id']
              "
            >
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" stroke="none">
                <path d="M8 5v14l11-7z" />
              </svg>
              Open
            </button>
            <button
              class="iconbtn danger"
              matTooltip="Delete"
              aria-label="Delete solution"
              (click)="openDialog(solution)"
            >
              <svg
                viewBox="0 0 24 24"
                width="17"
                height="17"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M3 6h18" />
                <path d="M8 6V4h8v2" />
                <path d="M6 6l1 14h10l1-14" />
              </svg>
            </button>
          </div>
        </div>

        <div class="empty" *ngIf="!availableSolutions?.length">
          No solutions yet — create your first one.
        </div>

        <div
          class="view-more-row"
          *ngIf="componentCheck && solutionMoreThanFive"
        >
          <span
            class="view-more"
            routerLink="/home/manage-solutions/mySolutions"
            >View More &raquo;</span
          >
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./my-solutions.component.scss'],
})
export class MySolutionsComponent implements OnInit {
  availableSolutions: any = [];
  componentCheck: boolean = false;
  solutionMoreThanFive: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private solutionServices: SolutionsAppService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private snackBar: SharedFeaturesService
  ) {}

  ngOnInit() {
    this.refreshAvailableSolution();
  }

  refreshAvailableSolution() {
    this.solutionServices.getAvailableSolution().subscribe((response: any) => {
      this.availableSolutions = response;
      if (this.route.component === MySolutionHomepageComponent) {
        this.componentCheck = false;
      } else {
        this.componentCheck = true;
        if (this.availableSolutions.length > 5)
          this.solutionMoreThanFive = true;
        this.availableSolutions = this.availableSolutions.slice(0, 5);
      }
    });
  }

  openDialog(solution: any): void {
    const dialogRef = this.dialog.open(ShowDialogsComponent, {
      disableClose: false,
      data: {
        title: 'Delete solution',
        message: `Delete '${solution.solution_name}'? This permanently removes the solution.`,
        confirmText: 'Delete',
        danger: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteSolution(solution);
      }
    });
  }

  deleteSolution(solution: any) {
    this.solutionServices.deleteSolution(solution).subscribe({
      next: (response: any) => {
        this.snackBar.openSnackBar(
          'solution deleted successfully',
          'Close',
          'success-snackbar'
        );
        this.refreshAvailableSolution();
      },
    });
  }

  openVersion(solution: any) {
    this.router.navigate(['/home/manage-solutions/mySolutions/']);
  }
}
